import { c as _c } from "react/compiler-runtime";
import { useBlogTemplate } from 'modules/blogs/hooks/use-blog-template';
import { BlogTemplateDataInterface, BlogTemplateItemInterface } from 'modules/blogs/types/blog-template-interface';
import { useEffect, useState } from 'react';
import { Loader } from 'shared/components/loader';
import { TemplateCard } from 'shared/components/template-card';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface TemplateSelectorProps {
  value?: BlogTemplateItemInterface['id'];
  onChange: (id: BlogTemplateItemInterface['id']) => void;
}
const TemplateSelector = t0 => {
  const $ = _c(13);
  const {
    value,
    onChange
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    data: templates
  } = useBlogTemplate();
  const [templatesData, setTemplatesData] = useState();
  let t1;
  let t2;
  if ($[0] !== templates) {
    t1 = () => {
      if (templates) {
        setTemplatesData(templates.items.map(_temp));
      }
    };
    t2 = [templates];
    $[0] = templates;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onChange || $[4] !== templatesData) {
    t3 = () => {
      if (templatesData && templatesData[0]) {
        onChange(templatesData[0].id);
      }
    };
    $[3] = onChange;
    $[4] = templatesData;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== templatesData) {
    t4 = [templatesData];
    $[6] = templatesData;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== onChange || $[9] !== t || $[10] !== templatesData || $[11] !== value) {
    t5 = templatesData ? templatesData.length === 0 ? <span className="flex justify-center">{t("dashboard.blog.templates_not_found")}</span> : <div className="min-h-[260px] overflow-auto" style={{
      height: "calc(100vh - 510px)"
    }}><ul className="flex flex-col flex-wrap items-center justify-center gap-5 pb-5 sm:flex-row">{templatesData?.map(template_0 => <TemplateCard key={template_0.id} preview={{
          href: `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${template_0.blogDomain}/${template_0.blogPath}`
        }} onSelect={() => onChange(template_0.id)} isActive={template_0.id === value}><img alt={template_0.name || ""} src={template_0.path || ""} className="absolute" /></TemplateCard>)}</ul></div> : <div className="flex justify-center"><Loader /></div>;
    $[8] = onChange;
    $[9] = t;
    $[10] = templatesData;
    $[11] = value;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default TemplateSelector;
function _temp(template) {
  return {
    id: template.id,
    path: template.previewPath,
    name: template.previewImage?.filename ?? null,
    blogPath: template.blog.path,
    blogDomain: template.blog.domain.domainName
  };
}